import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Components
import Layout from "../../../../Layout/Layout";
import CreateSupplierMasterModal from "../../../../Components/Modal/supplier_app/CreateSupplierMasterModal";
import Constants from "../../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";
import { useNavigate } from "react-router-dom";
import {
  addGRNDetailNumber,
  addPoDetailNumber,
  getGoodsReceivedNote,
} from "../../../../redux/feature/supplier_app/purchasingSlice";
import { addQualityCheckGRNNumber, getQualityCheckList } from "../../../../redux/feature/supplier_app/qualityCheckSlice";
import ShowStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import { SearchField } from "../../../../Components/formElements/SearchField";
import { currencyFormat, formatDateTime } from "../../../../common/Validations";
import CancelModal from "../../../../Components/Modal/supplier_app/common/CancelModal";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import { MessageCircle } from "lucide-react";
import ChatBox from "../../../../Components/ChatBox/ChatBox";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import SupplierConstants from "../../../../common/SupplierConstants";

const GoodsReceivedNoteList = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "Goods Received Note");

  let goods_received_noteData = useSelector(
    (state) => state?.purchasing?.goods_received_note
  ); // get goods_received_note from Store

  let goods_received_noteDataTable = useSelector(
    (state) => state?.purchasing?.goods_received_note?.pagination
  ); // goods_received_noteDataTable Details from Store

  let module = useSelector(
    (state) => state?.common?.data?.purchaseOrder?.GRN?.module
  ); // config Details from Store

  const [data, setData] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const [isCardVisible, setCardVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  // Show Status Modal
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal, setSendDataModal] = useState("");
  const [modelTitle, setModelTitle] = useState("");

  /* Modal Function */
  const showStatusInfo = (rowData) => {
    setModalShowStatus(true);
    setSendDataModal(rowData);
    setModelTitle("Status Information");
  };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const hideModal = () => {
    setModalShow(false);
  };

  const loadInitialPageData = async () => {
    setData(goods_received_noteData.data);
  };

  useEffect(() => {
    loadInitialPageData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [goods_received_noteData]);

  useEffect(() => {
    const fetchQcData = async () => {
      try {
        const res = await dispatch(getQualityCheckList({ page: 1, per_page: 500 })).unwrap();
        const qcData = res?.data || [];
        const map = {};
        qcData.forEach((qc) => {
          if (qc.grnNr) {
            map[qc.grnNr] = qc;
          }
        });
        setQcMap(map);
      } catch (err) {
        console.log("Error fetching QC data:", err);
      }
    };
    fetchQcData();
  }, [dispatch]);

  const handlePageChange = (page) => {
    let obj = {
      page: page,
      per_page: getNewPerPage,
      searchTerm: getCommonSearchTxt,
    };

    dispatch(getGoodsReceivedNote(obj));
    setData(goods_received_noteData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getGoodsReceivedNote(obj));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      page: page,
      per_page: newPerPage,
      searchTerm: getCommonSearchTxt,
    };
    setNewPerPage(newPerPage);
    dispatch(getGoodsReceivedNote(obj));
    setData(goods_received_noteData?.data);
  };

  const detailedPage = (grnNumber) => {
    dispatch(addGRNDetailNumber(grnNumber));
    navigate(Constants.POCOLLABRATION_GRN_DETAILS);
  };

  const detailedPagePO = (poNumber) => {
    dispatch(addPoDetailNumber(poNumber));
    navigate(Constants.POCOLLABRATION_PURCHASE_ORDER_DETAIL_PAGE);
  };

  const detailedPageQualityCheck = (grnNumber) => {
    dispatch(addQualityCheckGRNNumber(grnNumber));
    navigate(SupplierConstants.POCOLLABRATION_QUALITY_CHECK_CREATE);
  };

  // const qualityCreate = (grnNumber) => {
  //   dispatch(addPoDetailNumber(grnNumber));
  //   navigate(SupplierConstants.POCOLLABRATION_QUALITY_CHECK_CREATE);
  // };



  const columns = [
    {
      name: "Collaboration",
      cell: (row) => (
        <>
          <span className="iconTable">
            <button
              onClick={() => toggleChat(row.vendorCode)}
              title="Chat With the User"
            // className={`text-sm ${chatId === row.userId ? "text-green-600" : "text-blue-600"} hover:text-blue-800`}
            >
              <MessageCircle className="w-5 h-5" />
            </button>
          </span>
          <span>
            <i className="bi bi-collection-play iconTable"></i>
          </span>
          <span>
            <i className="bi bi-stack iconTable"></i>
          </span>
        </>
      ),
      width: "150px",
    },
    {
      name: "GRN Number",
      selector: (row) => row.grnNr,
      cell: (row) => (
        <button className="btnInfo" onClick={() => detailedPage(row.grnNr)}>
          {row.grnNr}{" "}
        </button>
      ),
      center:true,
      sortable: true,
      width: "150px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },
    // Conditionally include the 'workflowActionLogs' column
    ...(data?.some((row) => row.workflowActionLogs !== undefined)
      ? [
        {
          name: "Workflow log",
          selector: (row) => row.workflowActionLogs,
          cell: (row) => (
            <div
              style={{ width: "100%" }}
              className="d-flex justify-content-center iconTable"
            >
              <img
                src="assets/img/newIcons/workflow.png"
                alt="attachments"
                style={{ width: "35px" }}
                className="mt-1"
                onClick={() => showStatusInfo(row.workflowActionLogs)}
              />
            </div>
          ),
          sortable: true,
          width: "132px",
        },
      ]
      : []),

    {
      name: "Status",
      selector: (row) => row.grnStatusHeader,
      cell: (row) => (
        <>
          <TableStatusField status={row.grnStatusHeader} />
        </>
      ),
      center:true,
      sortable: true,
      width: "160px",
    },
    {
      name: "GRN Date/Time",
      selector: (row) => formatDateTime(row.createdAt) || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },


    {
      name: "GRN Value",
      selector: (row) => row.sumOfGrn || "--",
      cell: (row) => (
        <span className="numberFormate m-0 p-0 pt-1 fw-bold">
          {currencyFormat(Number(row.sumOfGrn).toFixed(2))}
        </span>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Currency",
      selector: (row) => row.currencyCode || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.currencyCode} </p>
          <p className="m-0 p-0">{row.currency} </p>
        </div>
      ),

      width: "150px",
    },
    {
      name: "PO/SA Number",
      selector: (row) => row.purchasingDocumentNr,
      cell: (row) => (
        <>
          {row.purchasingDocumentNr && (
            <button
              className="btnInfo"
              onClick={() => detailedPagePO(row.purchasingDocumentNr)}
            >
              {row.purchasingDocumentNr}{" "}
            </button>
          )}
          {!row.purchasingDocumentNr && (
            <>
              {" "}
              <p>--</p>{" "}
            </>
          )}
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "PO/SA Date/Time",
      selector: (row) => formatDateTime(row?.purchasingDocumentDate) || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "SAP GRN",
      selector: (row) => row.sapDocumentNumber,
      sortable: true,
      width: "200px",
    },
    {
      name: "Posted On",
      selector: (row) => row.postedOn || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Delivery Note",
      selector: (row) => row.deliveryNoteNo || "--",
      sortable: true,
      width: "140px",
    },
    {
      name: "Bill of Lading",
      selector: (row) => row.billOfLading || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Quality Check",
      cell: (row) => {
        const qc = qcMap[row.grnNr];
        if (qc) {
          return (
            <div style={{ whiteSpace: "nowrap", lineHeight: "1.6" }}>
              <span className="fw-bold" style={{ fontSize: "14px", color: "#1565c0" }}>
                {qc.qualityCheckNr}
              </span>
              <span className="text-muted" style={{ fontSize: "12px" }}> (</span>
              <span className="fw-bold" style={{ fontSize: "14px", color: "#000000" }}>Created</span>
              <span className="text-muted" style={{ fontSize: "12px" }}>)</span>
              <span className="text-muted d-block" style={{ fontSize: "12px" }}>
                {formatDateTime(qc.createdAt)}
              </span>
            </div>
          );
        }
        return (
          <button
            className="btnTable"
            onClick={() => detailedPageQualityCheck(row.grnNr)}
          >
            <i className="bi bi-check-circle"></i> Create
          </button>
        );
      },
      width: "200px",
    },
  ];

  const lineItemColInfo = [
    {
      name: "Item Nr",
      cell: (row) => <span>{row.grnItemNr} </span>,
      width: "180px",
    },
    {
      name: "Item Nr",
      cell: (row) => <span>{row.grnItemNr} </span>,
      width: "180px",
    },
    {
      name: "Material/Service",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
      width: "180px",
    },
    {
      name: "Material Group",
      cell: (row) => <span>{row.materialGroup} </span>,
      width: "220px",
    },
    {
      name: "PO Quantity",
      cell: (row) => <span>{row.purchaseQuantity} </span>,
      width: "220px",
    },

    {
      name: "GRN Quantity",
      cell: (row) => <span>{row.grnQuantity} </span>,
      width: "220px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
      width: "220px",
    },
    {
      name: "Delivery Date",
      cell: (row) => <span>{row.deliveryDate} </span>,
      width: "220px",
    },
    {
      name: "PO Nr",
      cell: (row) => <span>{row.purchasingDocumentNr} </span>,
      width: "220px",
    },
    {
      name: "PO Item Nr",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "220px",
    },
    {
      name: "Schedule Nr",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "220px",
    },
  ];
  /* Cancel Modal */
  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  const cancelModalShow = () => {
    setCancelModalStatus(true);
  };
  const cancelModalHide = () => {
    setCancelModalStatus(false);
  };

  /* Handle selected rows */
  const [getSelectedRows, setSelectedRows] = useState([]);
  const handleRowSelected = ({ selectedRows }) => {
    const validRows = selectedRows.filter(
      (item) => item?.grnStatusHeader !== "Cancelled"
    );
    setSelectedRows(validRows);
  };

  const [chatId, setChatId] = useState(null);
  const [qcMap, setQcMap] = useState({});
  const toggleChat = (groupId) => {
    // Toggle the same PR closes the chat
    if (chatId === groupId) {
      setChatId(null);
    } else {
      setChatId(groupId);
    }
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Goods Received Note</h2>
                <p className="subText">
                  Lists of Goods Received Note and details
                </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>

            <hr />

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={2} lg={2} className="text-center logoBtn">
                      <span className="iconLogo">GR</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">GRN List</span>
                      <span className="subHeaderTitle">
                        View of Goods Received Note and Status{" "}
                      </span>
                    </Col>
{/* <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => {
                          alert("asd");
                        }}
                      >
                        <i className="bi bi-file-excel"></i> Template
                      </button>
                    </Col> */}
                    <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                      <Col xs={6} md={6} lg={6}>
                        <button
                          className="btnTable"
                          onClick={cancelModalShow}
                          disabled={getSelectedRows.length > 0 ? false : true}
                        >
                          <i className="bi bi-x-circle"></i> Cancel
                        </button>
                      </Col>
                      <Col xs={6} md={1} lg={1}>
                        <POCollabrationCommonFillter />
                      </Col>
                      <Col xs={6} md={1} lg={1}>
                        <POCollabrationCommonFillter />
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                    }`}
                // aria-labelledby="headingOne"
                // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                       <StickyColumn
                        columnIndexes={[2, 3]}
                        leftOffsets={[0, 140]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={goods_received_noteData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={
                            goods_received_noteDataTable.total
                          }
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CreateSupplierMasterModal show={modalShow} onHide={() => hideModal()} />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <CancelModal
        title="Cancel the GRN"
        type={module}
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={getSelectedRows}
      />
      {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
        />
      )}
    </main>
  );
};

export default GoodsReceivedNoteList;
